import React from 'react';
import { observer } from 'mobx-react';
import { clientStore } from 'apps/client/app';
import Loading from 'components/Loading';
import { DisabledWrapperWithTooltip } from 'components';

export type OperateCheckerProps = {
  children: React.ReactElement;
  type: 'canCreateIn' | 'canUpdate' | 'canDeleteIn';
};

export const OperateChecker = observer(
  ({ type, children }: OperateCheckerProps) => {
    if (!clientStore?.operateChecker) {
      return <Loading text='Loading' />;
    }

    const canOperate = (clientStore.operateChecker as any)[type];

    if (canOperate) {
      return children;
    }

    // if no permission, disable the operate element
    return (
      <DisabledWrapperWithTooltip disabled={!canOperate}>
        {children}
      </DisabledWrapperWithTooltip>
    );
  },
);
